import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { ContractDto } from "@rentablo/api/contracts";
import { ContractFormValues } from "@features/contractAnalyzer/types";

const defaultProvider = (contract: ContractDto | undefined) =>
  contract?.userDefinedProvider
    ? contract.userDefinedProvider
    : (contract?.autoAssignedProvider?.name ?? "");

export const useContractForms = (contract: ContractDto | undefined) => {
  const { t } = useTranslation();
  const schema = Yup.object().shape({
    provider: Yup.string().required(t("form.errors.required")),
    comment: Yup.string().nullable(),
  });

  const contractForm = useForm<ContractFormValues>({
    mode: "onSubmit",
    resolver: yupResolver(schema),
    defaultValues: {
      provider: defaultProvider(contract),
      comment: contract?.comment ?? "",
    },
  });

  const secondContractForm = useForm<ContractFormValues>({
    mode: "onSubmit",
    resolver: yupResolver(schema),
    defaultValues: {
      provider: "",
      comment: "",
    },
  });

  useEffect(() => {
    if (contract) {
      contractForm.reset({
        provider: defaultProvider(contract),
        comment: contract.comment ?? "",
      });
      secondContractForm.reset({ provider: "", comment: "" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- reset on prop change
  }, [contract]);

  return { contractForm, secondContractForm };
};
